import { NgModule } from '@angular/core';

import { InspectionEmailComponent } from './inspection.email.component';
import { InspectionSmsComponent }   from './inspection.sms.component';
import { SharedModule }             from '../shared/shared.module';

@NgModule({
  declarations: [
    InspectionEmailComponent,
    InspectionSmsComponent
  ],
  entryComponents: [
    InspectionEmailComponent,
    InspectionSmsComponent
  ],
  imports: [
    SharedModule
  ]
})
export class InspectionsModule {}
